import en from "@/app/locales/en.json";
import th from "@/app/locales/th.json";

export default { en, th };
